import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CommonService } from '../common.service';
import { LinkedinService } from './linkedin.service';

import { LinkedinBtnComponent } from './linkedin-btn.component';
import { LinkedinImgComponent } from './linkedin-img.component';
import { LinkedinCardComponent } from './linkedin-card.component';

@NgModule({
  imports: [CommonModule],
  declarations: [
    LinkedinBtnComponent,
    LinkedinImgComponent,
    LinkedinCardComponent,
  ],
  exports: [
    LinkedinBtnComponent,
    LinkedinImgComponent,
    LinkedinCardComponent,
  ],
  providers: [
    CommonService,
    LinkedinService,
  ]
})
export class LinkedinModule { }



// WEBPACK FOOTER //
// ./src/app/social/linkedin/linkedin.module.ts